module.exports = __webpack_public_path__ + "img/pingshuxingyuyan.4ff2c384.png";